'use strict';
/* ==========================================================================
   core-local/hooks.js — the Energy lesson's hooks into the shared engine v2
   (shared/engine/v2/core/game.js reads window.LessonHooks).

   captions: fallback caption text + speaker for every line in the designer's
   content (script.json segments + responses, spot.json lines). The engine
   lays assets/vo/lines.json and who.json (what was actually recorded) over it.
   The STAMPED card text is plain data in lesson.json (steps[].card).
   speakers: the name tag and colour of each voice in the portrait dock's captions (core/dock.js).
   ========================================================================== */
window.LessonHooks = {
  speakers: { voss: { name: 'Dr. Voss', color: '#e0533d' }, max: { name: 'Max', color: '#2e9c8e' } },
  captions({ script, spot }) {
    const text = {}, who = {};
    const add = l => { text[l.id] = l.text; who[l.id] = l.who; };
    if (script) { script.segments.forEach(sg => (sg.lines || []).concat(sg.after || []).forEach(add)); (script.responses || []).forEach(add); }
    if (spot) (spot.lines || []).forEach(add);
    return { text, who };
  },
};
